import { type Location, useLocation } from 'react-router';

import { useDisclosure } from '@chakra-ui/react';

import type { MenuLocationState } from './types/location-state.type';

export const useMailingTypeMenuConfiguration = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const location = useLocation() as Location<MenuLocationState | undefined>;

  return { isOpen, onClose, onOpen, selectedMenu: location.state?.selectedMenu ?? 'internal-all' };
};
